import { type JSX } from 'react';

import { IBusinessCollectionQueryResult } from '../../../Features/Delsystem/_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { IUIUrval } from '../../../Types/UrvalTypes';
import { useContext } from 'react';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';
import { useBusinessCollectionQuery } from '../../../Features/Delsystem/_Common/Components/BusinessCollectionComponents/Queries/useBusinessCollectionQuery';
import { InternalError } from '../../InternalError/InternalError';
import ServerError from '../../ServerError/ServerError';

interface IProps {
  routineID?: number;
  collectionName: string;
  queryName?: string;
  attributeDefs: readonly string[];
  urval?: IUIUrval | null;
  urvalId?: string;
  children: (value: IBusinessCollectionQueryResult) => JSX.Element;
  onCompleted?: (data: any) => void;
  networkOnlyOnFirst?: boolean;
  skip?: boolean;
}

export const useActiveDBCollectionQuery = (
  props: Omit<IProps, 'children'>
): IBusinessCollectionQueryResult => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);

  const businessCollectionQueryResult = useBusinessCollectionQuery({
    collectionName: props.collectionName,
    queryName: props.queryName,
    columns: props.attributeDefs,
    urval: props.urval,
    urvalId: props.urvalId,
    databaseName: activeDatabaseContext.activeDatabase,
    routineID: props.routineID,
    onCompleted: props.onCompleted,
    networkOnlyOnFirst: props.networkOnlyOnFirst,
    skip: props.skip,
  });

  return businessCollectionQueryResult;
};

/**
  En kompination av ActiveDatabaseName och BusinessCollectionQuery så att man får samma interface som
  BusinessCollectionQuery men utan databasnamnet som istället hämntas från den aktuella routen.
*/
const ActiveDBCollectionQuery = (props: IProps) => {
  const result = useActiveDBCollectionQuery(props);

  if (!result.query.isOk()) {
    return (
      <InternalError
        id="194684b3-8314-4d40-8039-a7567edacb72"
        message={result.query.error}
      />
    );
  }

  if (result.serverError) {
    return <ServerError error={result.serverError} />;
  }

  return props.children(result);
};

export default ActiveDBCollectionQuery;
